export default __webpack_public_path__ + "static/media/photo-charte03.f0c601dc.png";